import React, { useMemo } from 'react';
import GalleryCarousel from '@/components/gallery/GalleryCarousel';

export default function ProjectGalleryCarousel({ media, mediaTypes = [], mediaMeta = [], projectTitle }) {
  const images = useMemo(() => media.map((src, index) => {
    const meta = mediaMeta[index] || {};
    return {
      id: `${src}-${index}`,
      src,
      alt: meta.description || meta.title || `${projectTitle} - immagine ${index + 1}`,
      type: mediaTypes[index] || 'image',
      meta,
      responsive: meta.responsive
    };
  }), [media, mediaMeta, mediaTypes, projectTitle]);

  return <GalleryCarousel images={images} ariaLabel={`Galleria del progetto ${projectTitle}`} enableZoom />;
}